import { Controller } from "@hotwired/stimulus"

const ACTIVE_CLASSES = ["text-white", "border-yellow-400", "hover:bg-white/10"]
const INACTIVE_CLASSES = ["bg-black", "text-white", "border-white/20", "hover:bg-white/10"]

export default class extends Controller {
  static targets = ["amount", "preset", "overlay", "submitButton"]

  connect() {
    this.amountChanged()
  }

  fillAmount(event) {
    event.preventDefault()
    const amount = parseInt(event.params.amount, 10)
    if (Number.isNaN(amount)) return

    if (this.hasAmountTarget) {
      this.amountTarget.value = amount
      this.amountTarget.dispatchEvent(new Event("input", { bubbles: true }))
      this.amountTarget.focus()
    }

    this.activatePreset(event.currentTarget)
  }

  amountChanged() {
    if (!this.hasAmountTarget) return

    const currentValue = parseInt(this.amountTarget.value, 10)
    let matchedButton = null

    if (!Number.isNaN(currentValue)) {
      matchedButton = this.presetTargets.find((button) => {
        const presetValue = parseInt(button.dataset.donationFormAmountParam, 10)
        return presetValue === currentValue
      }) || null
    }

    this.activatePreset(matchedButton)
  }

  activatePreset(button) {
    this.presetTargets.forEach((preset) => this.resetPreset(preset))
    if (button) {
      ACTIVE_CLASSES.forEach((klass) => button.classList.add(klass))
      INACTIVE_CLASSES.forEach((klass) => button.classList.remove(klass))
    }
  }

  resetPreset(button) {
    ACTIVE_CLASSES.forEach((klass) => button.classList.remove(klass))
    INACTIVE_CLASSES.forEach((klass) => {
      if (!button.classList.contains(klass)) {
        button.classList.add(klass)
      }
    })
  }

  showProcessingOverlay() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
    }

    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.add("opacity-50", "cursor-not-allowed")
    }
  }
}
